import React from 'react';
import { Input, Button } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { Logo } from 'assets/img';
import { AuthService } from 'services';
import { connect } from 'react-redux';
import * as Jetemit from 'jetemit';

interface Props extends RootState {
	onClose?: any;
	openRegister?: any;
	openReset?: any;
	dispatch?: any;
	history?: any;
}

class ModalLogin extends React.Component<Props> {

	state = {
		form: {
			email: '',
			password: ''
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.email) {
			Globals.showError("Debe ingresar el correo electrónico");
			return;
		}
		if (!this.state.form.password) {
			Globals.showError("Debe ingresar la contraseña");
			return;
		}
		const res: any = await AuthService.login(this.state.form);
		await this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
		await this.props.dispatch({
			type: 'SET_QUOTE_BEFORE_LOGIN',
			payload: null
		});
		if (res.user?.level_id == Constants.LEVELS.CLIENT) {
			this.props.onClose(true);
		}
		else {
			this.props.history.replace('/');
		}
	}

	render() {
		return (
			<form id="modal-quotes-login" onSubmit={ this.submit }>
				<div className="text-center">
					<img src={ Logo } className="logo" />
				</div>
				<Input 
					placeholder="Correo Electrónico"
					name="email" 
					value={ this.state.form.email }
					onChange={ this.change } />
				<Input
					placeholder="Contraseña"
					type="password"
					name="password"
					onChange={ this.change } />
				<div className="text-right">
					<Link to="/" onClick={ (e: any) => {
						e.preventDefault();
						this.props.openReset();
					} }>
						¿Contraseña olvidada?
					</Link>
				</div>
				<button className="btn btn-login" type="submit">
					Iniciar Sesión
				</button>
				<button className="btn btn-register" type="button" onClick={ () => this.props.openRegister() }>
					Registrarme
				</button>
			</form>
		)
	}
}

export default connect()(ModalLogin);